// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  margin: 0;
}
.grid.filters {
  grid-template-columns: repeat(2, auto);
}
.filters {
  padding-bottom: 51px;
}
#invoice-list-filters {
  margin-left: 10px;
  width: 97%;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/app/invoice/invoice-list/invoice-list.component.less"],"names":[],"mappings":"AAEA;EACI,SAAA;AADJ;AAGA;EACI,sCAAA;AADJ;AAIA;EACI,oBAAA;AAFJ;AAKA;EACI,iBAAA;EACA,UAAA;EACA,wCAAA;AAHJ","sourcesContent":["@import (reference) url(\"../../../styles.less\");\n\nh1 {\n    margin: 0;\n}\n.grid.filters {\n    grid-template-columns: repeat(2, auto);\n}\n\n.filters {\n    padding-bottom: 51px;\n}\n\n#invoice-list-filters {\n    margin-left: 10px;\n    width: 97%;\n    box-shadow: 0 0 0 1px rgba(0,0,0,.2);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
